import { orderedListElementType } from "./OrderedListElement.js";
import { unorderedListElementType } from "./UnorderedListElement.js";
const unorderedListToolbarButton = {
  elementType: unorderedListElementType,
  blueprintIcon: "properties",
  label: "Bullet list",
  title: "Bullet list"
};
const orderedListToolbarButton = {
  elementType: orderedListElementType,
  blueprintIcon: "numbered-list",
  label: "Numbered list",
  title: "Numbered list"
};
export {
  orderedListToolbarButton,
  unorderedListToolbarButton
};
//# sourceMappingURL=listToolbarButtons.js.map
